<template>
  <div>
    <div class="dashheader">
      <a-row :gutter="18">
        <a-col :sm="24" :md="24" :xl="8" :style="{ marginBottom: '24px' }">
          <AreaChartCard ref="loginAreaChart" :loading="chartLoading" :title="$t('charts.totalLogin')"
            :chartTips="$t('charts.totalLogin')" :total="loginChartData.total" :rightTitle="$t('charts.dayLogin')"
            :rightNum="loginChartData.today" uniqueId="areacontainer2"></AreaChartCard>
        </a-col>
        <a-col :sm="24" :md="24" :xl="8" :style="{ marginBottom: '24px' }">
          <AreaChartCard ref="areaChart" :loading="chartLoading" :title="$t('charts.totalViews')"
            :chartTips="$t('charts.totalViews')" :total="chartData.total" :rightTitle="$t('charts.dayViews')"
            :rightNum="chartData.today" theme="#ea4856" uniqueId="areacontainer1"></AreaChartCard>
        </a-col>
        <a-col :sm="24" :md="24" :xl="8" :style="{ marginBottom: '24px' }">
          <a-card :body-style="{ padding: '20px 24px 8px' }" :bordered="false">
            <div class="card-header">
              <span class="card-title">{{
                $t("descriptions.accountInfo")
              }}</span>
            </div>
            <div class="card-middle">
              <img :src="form
                    ? form.team_id
                      ? form.team_user_avatar
                        ? form.team_user_avatar
                        : avatar
                      : form.avatar
                        ? form.avatar
                        : avatar
                    : avatar
                  " class="header-avatar" />
              <div class="middle-right">
                <span class="phone">{{ form.phone }}</span>
                <a-button type="link" @click="clickToEdit">{{
                  $t("actionTitles.edit")
                }}</a-button>
                <br />
                <span class="address">{{ form.address }}</span>
                <br />
                <a-tag color="#121212" v-if="form.team_id > 0">{{
                  $t("enum.userLevel.3")
                }}</a-tag>
                <a-tag color="#1890ff" v-if="form.team_id == 0 && form.level == 0">{{ $t("enum.userLevel.0") }}</a-tag>
                <a-tag color="#66b4c1" v-if="form.team_id == 0 && form.level == 1">{{ $t("enum.userLevel.1") }}</a-tag>
                <a-tag color="#bc9c5c" v-if="form.team_id == 0 && form.level == 2">{{ $t("enum.userLevel.2") }}</a-tag>
                <span v-if="form.level > 0">{{ userDetail.expire_desc }}
                  {{ $t("descriptions.expire") }}</span>
              </div>
            </div>
            <div class="card-bottom" v-if="form.team_id > 0">
              <span class="storage-percent">{{ userDetail.team_use_capacity }}G/{{
                userDetail.team_capacity
              }}G</span>
              <a-progress :percent="userDetail.team_capacity_ratio" :show-info="false" />
            </div>
            <div class="card-bottom" v-else>
              <span class="storage-percent">{{ userDetail.g_use_capacity }}G/{{
                userDetail.g_capacity
              }}G</span>
              <a-progress :percent="userDetail.progress" :show-info="false" />
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <div class="dash-table">
      <a-table :data-source="pageResult.data" :loading="loading" rowKey="id" :pagination="pagination"
        @change="handleTableChange">
        <a-table-column key="name" :title="$t('table.common.thead.publish')" data-index="name" align="center">
          <template slot-scope="text, record">
            <a-row type="flex" align="middle">
              <img :src="record.thumb_path" alt style="width: 40px; border-radius: 5px; cursor: pointer"
                @click="toTour(record)" />
              <div style="margin-left: 5px">
                <span class="work-name" @click="toTour(record)">{{
                  record.name
                }}</span>
                <br />
                <span>{{ record.regoin_name }}</span>
              </div>
            </a-row>
          </template>
        </a-table-column>

        <a-table-column key="readCount" :sorter="(a, b) => a.total_browse - b.total_browse"
          :title="$t('table.work.thead.readCount')" data-index="total_browse" align="center" />

        <a-table-column key="status" :title="$t('table.common.thead.state')" data-index="is_public" :filters="filters"
          align="center">
          <template slot-scope="text, record">{{
            $t(`enum.workIsPublic.${record.is_public}`)
          }}</template>
        </a-table-column>

        <a-table-column key="updateTime" :sorter="(a, b) => a.update_time - b.update_time"
          :title="$t('table.common.thead.updateTime')" data-index="update_time" align="center" />
      </a-table>
    </div>
    <a-modal :visible="updateNewsInfo" :width="750" :title="$t('message.updateVersionNotice')" :footer="null"
      @cancel="closeUpdateNewsInfo">
      <div class="updateNews-Info">
        <img src="@/assets/img/update20240119.jpg" alt="">
      </div>
    </a-modal>
    <a-modal :visible="isModalVisible" :width="800" :footer="null" @cancel="closeUpdateInfo" ref="updateModal">
      <div class="update-Info">
        <img src="@/assets/img/updateNotify.png" alt="" />
        <p class="notify">
          {{ $t("upgradeNotify.notify") }}
          <span class="updated">
            {{ $t("upgradeNotify.updated") }}
          </span>
        </p>
        <!-- <img src="@/assets/img/updateTitle.png" alt="" /> -->
        <a-table :data-source="noticeList" @change="handleTableChange" :row-key="record => record.id"
          style="width: 100%; font-weight: bolder;" :pagination="false" :row-selection="rowSelection"
          :scroll="{ y: 200 }">
          <!-- 作品名稱 -->
          <a-table-column key="name" :title="$t('table.common.thead.name')" data-index="name">
            <template slot-scope="text, record">
              <div class="item-container">
                <!-- <a-row type="flex" align="middle"> -->
                <div class="imgMerge">
                  <img src="@/assets/img/3Dicon.png" class="icon3D">
                  <img :src="record.thumb_path" alt style="width: 40px; border-radius: 5px; margin-right: 1%" />
                </div>
                <div v-if="record.dir_id === undefined || record.dir_id !== undefined">
                  <span class="toFolder">
                    <span class="newYellow">new</span>
                    {{ record.name }}
                  </span>
                </div>
                <span v-if="record.dir_ud !== undefined">{{ record.regoin_name }}</span>
                <!-- </a-row> -->
              </div>
            </template>
          </a-table-column>
          <!-- 客戶 -->
          <a-table-column key="customer_name" :title="$t('table.work.thead.customerName')" data-index="customer_name"
            align="center">
            <template slot-scope="text, record">
              <div v-if="record.customer_name">
                <span>{{ record.customer_name }}</span>
              </div>
            </template>
          </a-table-column>
          <!-- 閱讀次數 -->
          <a-table-column key="total_browse" :title="$t('table.work.thead.readCount')" data-index="total_browse"
            align="center" class="totalBrowse">
            <template slot-scope="text, record">
              {{ record.total_browse != undefined ? record.total_browse : "-" }}
            </template>
          </a-table-column>
        </a-table>
        <a-button class="confirm" type="primary" @click="confirm">
          {{ $t("hurryUp") }}
        </a-button>
      </div>
      <template #title>
        <span style="font-weight: bolder">{{ $t("updateHouseInfo") }}</span>
      </template>
    </a-modal>
  </div>
</template>

<script>
import AreaChartCard from "@/components/Charts/AreaChartCard";
import { pageQueryWork } from "@/api/work";
import {
  getVisitDateStatist,
  getLoginRecordDateStatist,
} from "@/api/statistic";
import { mapGetters } from "vuex";
import { getUserInfo } from "@/api/user";
// import Swal from "sweetalert2";

export default {
  components: { AreaChartCard },
  computed: {
    ...mapGetters(["userInfo"]),
    rowSelection() {
      return {
        onchange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name,
          },
        }),
      }
    },
  },
  data() {
    return {
      tableData: [],
      updateInfo: false,
      updateNewsInfo: false,
      wid_3d: null,
      filters: [
        {
          text: `${this.$t("enum.workIsPublic[1]")}`,
          value: "1",
        },
        {
          text: `${this.$t("enum.workIsPublic[0]")}`,
          value: "0",
        },
      ],
      form: {
        avatar: "",
        phone: "",
        address: "",
      },
      chartLoading: false,
      loading: false,
      pageResult: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {
        order: {
          create_time: "desc",
          total_browse: "desc",
        },
        is_public: [],
      },
      chartData: {
        total: 0,
        today: 0,
      },
      loginChartData: {
        total: 0,
        today: 0,
      },
      userDetail: {},
      avatar: require("@/assets/default_h.jpg"),
      noticeList: [],
      isModalVisible: false,
      noticeInfo: {},
    };
  },
  created() {
    this.getDatas();
    this.form = this.userInfo;
    this.userInfo.expire_time = this.userInfo.expire_time.substring(0, 11);
    getUserInfo().then((res) => {
      this.userDetail = res.data;
      this.userDetail.expire_time = this.userDetail.expire_time.substring(
        0,
        11
      );
      this.noticeList = res.data.notice_List;
      this.noticeInfo = res.data.notice_List;
      this.isModalVisible = this.noticeList.length > 0;
    });
    //獲取圖表數據
    getVisitDateStatist()
      .then((res) => {
        const data = res.data;
        this.chartData.total = data.total_count;
        this.chartData.today = data.today_count;
        if (data.statistics_data) {
          this.updateChartsData(data.statistics_data);
        }
      })
      .catch((err) => {
        // this.$message.error(err);
      });
    //獲取登入次數圖表數據
    getLoginRecordDateStatist()
      .then((res) => {
        const data = res.data;
        this.loginChartData.total = data.total_count;
        this.loginChartData.today = data.today_count;
        if (data.statistics_data) {
          this.updateLoginChartsData(data.statistics_data);
        }
      })
      .catch((err) => {
        // this.$message.error(err);
      });
    const updateInfoValue = sessionStorage.getItem("updateInfo");
    console.log(updateInfoValue);
    if (updateInfoValue || this.form.pid == 2039) {
      this.updateInfoValue = false;
    } else {
      this.updateInfoValue = true;
      sessionStorage.setItem("updateInfo", "true");
    }
  
  },
  methods: {
    closeUpdateInfo() {
      this.isModalVisible = false;
    },
    closeUpdateNewsInfo() {
      this.updateInfoValue = false;
    },
    confirm() {
      this.closeUpdateInfo();
    },

    updateChartsData(data) {
      this.$refs.areaChart.update(data);
    },
    updateLoginChartsData(data) {
      this.$refs.loginAreaChart.update(data);
    },
    clickToEdit() {
      this.$router.push("/member/account/basic");
    },
    getDatas() {
      this.loading = true;
      this.searchParam = {
        ...this.searchParam,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      pageQueryWork(this.searchParam)
        .then((res) => {
          this.loading = false;
          this.pageResult = res.data;
          this.pagination.total = res.data.total;
        })
        .catch((err) => (this.loading = false));
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;

      const pager = { ...this.pagination };
      if (Object.keys(filters).length > 0) {
        this.searchParam.is_public = filters.status;
      }

      if (sorter.field === "update_time") {
        this.searchParam.order.create_time =
          sorter.order === "ascend" ? "asc" : "desc";
      }

      if (sorter.field === "total_browse") {
        this.searchParam.order.total_browse =
          sorter.order === "ascend" ? "asc" : "desc";
      }

      this.getDatas();
    },
    toTour(item) {
      const { href } = this.$router.resolve({
        path: (item.type == 2 ? "/live/" : "/tour/") + `${item.uuid}`,
      });
      window.open(href, "_blank");
    },


  },
};
</script>

<style  scoped>
.dash-table {
  background-color: #ffffff;
}

.card-header {
  position: relative;
  overflow: hidden;
  width: 100%;
  line-height: 150%;
}

.card-title {
  color: rgba(179, 179, 179, 1);
  font-size: 14px;
}

.card-middle {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.card-bottom {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.header-avatar {
  margin-right: 16px;
  width: 60px;
  height: 60px;
  border-radius: 100%;
}

.middle-right {}

.phone {
  font-size: 16px;
  color: #000000;
  text-align: left;
  font-weight: bold;
  line-height: 150%;
}

.address {
  color: rgba(166, 166, 166, 1);
  font-size: 12px;
  line-height: 150%;
  text-align: left;
}

.storage-percent {
  margin-right: 10px;
}

.work-name:hover {
  cursor: pointer;
  color: #1890ff;
}

.update-Info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.updateNews-Info {
  display: flex;
  align-content: center;
}

.confirm {
  margin-top: 3%;
}

.notify {
  font-size: 18px;
  font-weight: bolder;
  color: #000000;
}

.updated {
  color: #015c61;
}

.item-container {
  border: 2px solid red;
  padding: 8px;
  border-radius: 5px;
  width: 250px;
  display: flex;
}

.toFolder {
  display: inline-block;
  width: 200px;
}

.newYellow {
  background-color: rgb(255, 181, 23);
  color: #000000;
  padding: 1%;
  margin-left: 2%;
}

.imgMerge {
  position: relative;
}

.icon3D {
  width: 50%;
  height: auto;
  position: absolute;
  top: -7px;
  left: -7px;
}
</style>
